import { useState } from "react";
import { Box, Button } from "@mui/material";

import DashboardRenderer from "../Dashboard/DashboardRenderer";
import { isTyvasoProductSelection } from "../myPerformanceHelpers";

/**
 * Config-driven pill tabs + per-tab DashboardRenderer. Shared by SALESREP and
 * RBD; the tab set, labels, layouts, switch options and unavailable widgets
 * all come from {@link roleViewConfig}. Only the active tab is mounted (same as
 * the previous sales-rep-only implementation), so switching remounts the grid.
 */
export default function RoleWidgetTabs({
  roleKey,
  config,
  widgetProps,
  selectedProduct,
}) {
  const tabs = config?.tabs || [];
  const [activeTab, setActiveTab] = useState(tabs[0]?.id);
  const unavailableWidgetTypes = config?.unavailableWidgetTypes || null;
  const isTyvaso = isTyvasoProductSelection(selectedProduct);

  const buildExtras = (tab) => {
    const extras = [
      ...(tab.extraSwitchOptions || []),
      ...(isTyvaso && tab.tyvasoExtraSwitchOptions
        ? tab.tyvasoExtraSwitchOptions
        : []),
    ];
    return extras.length ? extras : null;
  };

  return (
    <>
      <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", mb: 3 }}>
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <Button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              variant={isActive ? "contained" : "outlined"}
              sx={{
                textTransform: "none",
                borderRadius: 999,
                px: 2.5,
                py: 0.9,
                fontWeight: 600,
                fontSize: 14,
                boxShadow: "none",
                borderColor: "#D0D7DE",
                color: isActive ? "#FFFFFF" : "#1F2937",
                bgcolor: isActive ? "#005A9C" : "#FFFFFF",
                "&:hover": {
                  boxShadow: "none",
                  borderColor: isActive ? "#005A9C" : "#BFC7CF",
                  bgcolor: isActive ? "#00508B" : "#F9FBFD",
                },
              }}
            >
              {tab.label}
            </Button>
          );
        })}
      </Box>

      {tabs.map((tab) => {
        if (tab.id !== activeTab) return null;
        return (
          <DashboardRenderer
            key={tab.id}
            roleKey={roleKey}
            widgetProps={widgetProps}
            layoutScope={tab.layoutScope}
            defaultLayoutOverride={tab.defaultLayout}
            switchOptionsOverride={tab.switchOptions}
            extraSwitchOptionsOverride={buildExtras(tab)}
            unavailableWidgetTypes={unavailableWidgetTypes}
          />
        );
      })}
    </>
  );
}
